export default {
    bekendURI: import.meta.env.VITE_API_URL,
    openApiFileLocation: `${import.meta.env.VITE_API_URL}/openapi.json`,
    longDateTimeFormatOptions: {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
    } as const,
    requests: {
        concurrency: 3,
    },
    activity: {
        // Heartbeat interval in milliseconds (30 seconds)
        heartbeatIntervalMs: 30 * 1000,
    },
    gDrivePicker: {
        apiKey: import.meta.env.VITE_GDRIVE_PICKER_API_KEY,
        clientId: import.meta.env.VITE_GDRIVE_CLIENT_ID,
        scope: "https://www.googleapis.com/auth/drive.readonly",
    },
    authentication: {
        firebase: {
            apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
            authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
            databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
            projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
            storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
            messagingSenderId: import.meta.env
                .VITE_FIREBASE_MESSAGING_SENDER_ID,
            appId: import.meta.env.VITE_FIREBASE_APP_ID,
            measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
            emulatorUrl: import.meta.env.VITE_FIREBASE_EMULATOR_URL,
        },
    },
    features: {
        spex: false,
    },
    policyVersions: {
        privacy: "2025-08-09",
        terms: "2025-08-09",
    },
};
